import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import TemplateGallery from "@/components/website-templates/TemplateGallery";

/** Vitrine publique des modèles de site, accessible aux visiteurs du tunnel (aucune donnée de compte). */
export default function GalerieModeles() {
  const navigate = useNavigate();
  const { user } = useAuth();
  // Connecté : on reste sur les modèles ; visiteur : on l'invite à créer son compte
  const creer = () => (user ? document.getElementById("modeles-liste")?.scrollIntoView({ behavior: "smooth" }) : navigate("/auth"));
  return (
    <div className="min-h-screen bg-background">
      <div className="border-b border-border/50 bg-card/30 backdrop-blur px-6 py-3 flex items-center justify-between">
        <h1 className="text-lg font-bold">Modèles de site Grafton IA</h1>
        <Button size="sm" onClick={creer}>{user ? "Choisir un modèle" : "Créer mon site"}</Button>
      </div>
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="max-w-2xl mb-10">
          <h2 className="text-2xl md:text-3xl font-bold">Un site pensé pour votre secteur</h2>
          <p className="text-sm text-muted-foreground mt-2">Choisissez un modèle ou décrivez votre activité : Grafton prépare une première version que vous relisez et ajustez.</p>
        </div>
        <TemplateGallery selected="" onSelect={() => navigate(user ? "/modeles" : "/auth")} />
      </div>
    </div>
  );
}
